export const siteLinks = {
  login: "https://auth.grsoft.com.do/",
  requestDemo: "https://auth.grsoft.com.do/if/flow/enrollment/",
  contactEmail: "contacto@grsoftmedia.com.do",
};
